//#region IMPORT
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import { getColumnDefs1, getColumnDefs2 } from './GON_BASIC_ColumnDefs';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setSearchText } from '../../../../Reducer/SearchReducer';
//#endregion

/**
 * 공종 관리 화면 (Gongjong)
 * - 왼쪽: 부서 목록 그리드 (GetDepLast)
 * - 오른쪽: 선택한 부서의 공정 목록 그리드 (GetGonBasicR1)
 * - 조회조건: 사업장
 */
function GON_BASIC(props) {
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);

  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2(props);

  const selectedDep = props.selectedRowData1?.[0];
  const depName =
    selectedDep?.depNmLast ||
    selectedDep?.depNm4 ||
    selectedDep?.depNm3 ||
    selectedDep?.depNm2 ||
    selectedDep?.depNm1 ||
    '';
  const rowData2 = props.rowData2 || [];
  const uniqueDepCds = [...new Set(rowData2.map((r) => r.depCd).filter(Boolean))];
  const hasMultipleDepts = uniqueDepCds.length > 1;
  const title2 = hasMultipleDepts
    ? '공정 목록 (저장 시 각 행의 부서로 등록됩니다)'
    : depName
      ? `${depName} 의 공정 목록`
      : '공정 목록';

  return (
    <>
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xls,.xlsx"
        onChange={(e) => {
          props.onExcelFileChange?.(e);
          e.target.value = '';
        }}
      />
      <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Gongjong"
          searchYn="Y"
          saveYn="Y"
          printYn="N"
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo?.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList || [],
                    value: searchInfo.coCd || '',
                    onChange: async (e) => {
                      await props.handleCoChange?.(e);
                      await props.SearchLogic1?.();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList || [],
              value: searchInfo.custCd || '',
              onChange: async (e) => {
                await props.handleCustChange?.(e);
                await props.SearchLogic1?.();
              },
            },
          ]}
          placeholder="검색"
          searchClick={(e) => {
            dispatch(setSearchText(e));
            props.gridRef1?.current?.api?.setQuickFilter(e);
          }}
          saveClick={() => props.SaveLogic2?.()}
          grids={
            <BusinessGridGridCommon
              leftSize={30}
              rightSize={70}
              getRowId1={(params) => String(params.data?.no ?? params.data?.depCd ?? params.rowIndex)}
              getRowId2={(params) => String(params.data?.no ?? params.rowIndex)}
              gridRef1={props.gridRef1}
              gridRef2={props.gridRef2}
              columnDefs1={columnDefs1}
              columnDefs2={columnDefs2}
              rowData1={props.rowData1}
              rowData2={props.rowData2}
              setSelectedRowData1={props.setSelectedRowData1}
              setSelectedRowData2={props.setSelectedRowData2}
              setChangedRowData1={props.setChangedRowData1}
              setChangedRowData2={props.setChangedRowData2}
              title1="부서 목록"
              title2={title2}
              editable2={true}
              addYn1="N"
              addYn2="Y"
              deleteYn1="N"
              deleteYn2="Y"
              //saveYn2="Y"
              //saveClick2={() => props.SaveLogic2?.()}
              fileUploadYn2="Y"
              fileDownloadYn2="Y"
              refreshYn2="Y"
              refreshClick1={() => props.SearchLogic1?.()}
              refreshClick2={() => {
                const dep = props.selectedRowData1?.[0];
                if (dep) props.SearchLogic2?.(dep);
              }}
              addClick2={props.AddClick2}
              deleteClick2={props.MarkedForDeletion2}
              fileUploadClick2={props.FileUploadClick2}
              fileDownloadClick2={props.FileDownloadClick2}
              onCellValueChanged2={(e) => {
                if (!e.data) return;
                const row = { ...e.data };
                props.setChangedRowData2?.((prev) => {
                  const rest = (prev || []).filter((r) => r.no !== row.no);
                  return [...rest, row];
                });
              }}
              onCellClicked1={(e) => {
                const clickedIndex = e.rowIndex;
                if (props.currentRowIndexRef1?.current === clickedIndex) return;
                props.SearchLogic2?.(e.data);
                props.handleRowSelection1?.(e.data, clickedIndex);
              }}
              onSelectionChanged1={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi?.getSelectedNodes() ?? [];
                const selectedData = selectedNodes.map((n) => n.data);
                if (props.selectedRowNosRef1?.current) {
                  props.selectedRowNosRef1.current = new Set(
                    selectedData.map((r) => r.no ?? r.depCd)
                  );
                }
                props.setSelectedRowData1?.(selectedData);
              }}
              onSelectionChanged2={() => {
                const gridApi = props.gridRef2?.current?.api;
                const selectedNodes = gridApi?.getSelectedNodes() ?? [];
                const selectedData = selectedNodes.map((n) => n.data);
                if (props.selectedRowNosRef2?.current) {
                  props.selectedRowNosRef2.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                }
                props.setSelectedRowData2?.(selectedData);
              }}
            />
          }
        />
      </Grid>
    </Grid>
    </>
  );
}

export default GON_BASIC;
